// removed by extract-text-webpack-plugin
module.exports = {"readOnly":"c-IngridWidget2__readOnly","message":"c-IngridWidget2__message"};